import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, onSnapshot, query, where } from 'firebase/firestore';
import { db } from '../../firebase';
import { FixRecords } from '../../components/ui/FixRecords';
import { ShowAbsences } from '../../components/ui/ShowAbsences';
import { ShowFestivo } from '../../components/ui/ShowFestivo';
import moment from 'moment';

import './styles/Notifications.css';

export const Notifications = () => {
  // Lista de notificaciones pendientes recibidas desde Firestore
  const [notifications, setNotifications] = useState([]);

  // Notificación seleccionada actualmente para mostrar su detalle en el panel derecho
  const [activeNotifications, setActiveNotifications] = useState(null);

  // Referencia al contenedor modal para gestionar el scroll vertical
  const modal = useRef(null);

  const navigate = useNavigate();

  // Bloquea el scroll del cuerpo de la página mientras el modal está abierto
  // y lo restaura al desmontar el componente o navegar fuera
  useEffect(() => {
    document.querySelector('body').style.overflow = 'hidden';
    return () => {
      document.querySelector('body').style.overflow = 'auto';
    };
  }, []);

  // Cierra el centro de notificaciones y regresa a la ruta principal
  const exit = () => {
    document.querySelector('body').style.overflow = 'auto';
    navigate('/');
  };

  useEffect(() => {
    const unsubscribe = onSnapshot(query(collection(db, 'notifications'), where('processed', '==', false)), (documents) => {
      var arrRecords = [];
      const today = moment().format('YYYY-MM-DD');

      documents.forEach((document) => {
        const notif = { id: document.id, ...document.data() };

        if (notif.type === 'Festivo') {
          // Obtener la fecha del festivo desde holidayDate o notificationDate
          const holiday = notif.holidayDate
            ? moment(notif.holidayDate, 'DD-MM-YYYY').format('YYYY-MM-DD')
            : moment(notif.notificationDate?.toDate ? notif.notificationDate.toDate() : notif.notificationDate).format('YYYY-MM-DD');

          // Solo se muestra al día siguiente del festivo para asegurar todos los registros del día
          if (today > holiday) {
            arrRecords.push(notif);
          }
        } else {
          // Resto de tipos (Error_fichaje, Error_app, Vacaciones, etc.) se muestran inmediatamente
          arrRecords.push(notif);
        }
      });
      setNotifications(arrRecords);
    });

    return () => unsubscribe();
  }, []);

  const onSelected = (data) => {
    setActiveNotifications(data);
    if (modal.current) {
      modal.current.scrollTop = 0;
    }
  };

  return (
    <div className='modal-route' ref={modal}>
      <div className='notifications'>
        <div className='modal-header'>
          <h5 className='modal-title'>
            <i className='fa-regular fa-bell'></i>Notificaciones
          </h5>
          <button type='button' className='btn-close' onClick={() => exit()}></button>
        </div>
        <div className='modal-body'>
          <div className='row'>
            <div className='col-md-3'>
              <ul className='nav nav-pills nav-stacked'>
                {notifications.map((data) => (
                  <li className='mb-4' key={data.id}>
                    <a data-toggle='pill' onClick={() => onSelected(data)}>
                      <div className='card'>
                        <div className='card-header'>
                          <div className='row'>
                            <div className='col-xs-4 col-lg-8'>
                              <img src={data.avatar} alt='Avatar' className='avatar' />
                              <p>Solicitud: {data.name}</p>
                            </div>
                            <div className='col-xs-5 col-lg-4'>
                              <span className={`btn btn-outline float-end ${data.type}`}>{data.type}</span>
                            </div>
                          </div>
                        </div>
                        <div className='card-body'>
                          {data.type === 'Festivo' ? (
                            <p>{data.name} ha registrado un fichaje en festivo </p>
                          ) : (
                            <p>{data.name} ha solicitado revisar los siguientes registros de fichaje</p>
                          )}
                        </div>
                      </div>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div className='col-md-9'>
              <div className='tab-content'>
                {activeNotifications ? (
                  // Caso 1: Incidencias de fichaje manual o fallos de app -> FixRecords
                  activeNotifications.type === 'Error_fichaje' || activeNotifications.type === 'Error_app' ? (
                    <FixRecords data={activeNotifications} />
                  ) : // Caso 2: Fichajes en día festivo -> ShowFestivo
                  activeNotifications.type === 'Festivo' ? (
                    <ShowFestivo data={activeNotifications} />
                  ) : (
                    // Caso 3: Solicitudes de ausencias (vacaciones, asuntos propios, etc.) -> ShowAbsences
                    <ShowAbsences data={activeNotifications} />
                  )
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
